import axios from "axios";
import {
  GET_NOTIFICATIONS,
  SEND_CASUAL_NOTIFICATION,
  ACCEPTED_CASUAL_NOTIFICATION,
  ACCEPTED_APPROVAL_NOTIFICATION,
  FOLLOWER_NOTIFICATION,
  APPROVAL_NOTIFICATION,
  NOTIFICATION_ERROR,
  CLEAR_NOTIFICATIONS,
  DELETE_NOTIFICATION,
  DELETE_NOTIFICATIONS,
} from "./types";

// Get user's notifications
export const getNotifications = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/notification");
    dispatch({ type: CLEAR_NOTIFICATIONS });

    dispatch({
      type: GET_NOTIFICATIONS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: NOTIFICATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Send casual friend notification
export const casualNotification = (channelid) => async (dispatch) => {
  try {
    const res = await axios.post(`/api/notification/${channelid}`);

    dispatch({
      type: SEND_CASUAL_NOTIFICATION,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: NOTIFICATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Accepted casual friend notification
export const acceptedCasualNotification = (channelid) => async (dispatch) => {
  try {
    const res = await axios.post(`/api/notification/accepted/${channelid}`);

    dispatch({
      type: ACCEPTED_CASUAL_NOTIFICATION,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: NOTIFICATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Accepted casual friend notification
export const acceptedApprovalNotification = (channelid) => async (dispatch) => {
  try {
    const res = await axios.post(
      `/api/notification/acceptedapproval/${channelid}`
    );

    dispatch({
      type: ACCEPTED_APPROVAL_NOTIFICATION,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: NOTIFICATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// New follower notification
export const newFollowerNotification = (channelid) => async (dispatch) => {
  try {
    const res = await axios.post(`/api/notification/follower/${channelid}`);

    dispatch({
      type: FOLLOWER_NOTIFICATION,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: NOTIFICATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

//Delete a notification
export const deleteNotification = (id) => async (dispatch) => {
  const formData = new FormData();

  formData.append("id", JSON.stringify(id));

  const config = {
    data: formData,
    header: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const res = await axios.post(
      `/api/notification/delete/${id}`,
      formData,
      config
    );

    dispatch({
      type: DELETE_NOTIFICATION,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: NOTIFICATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

//Delete all notifications
export const deleteNotifications = () => async (dispatch) => {
  try {
    const res = await axios.post(`/api/notification/delete/notifications`);

    dispatch({
      type: DELETE_NOTIFICATIONS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: NOTIFICATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Remove any "user followed" notifications when user requests to unfollow
export const declineCasualFriendRequest = (channelid) => async (dispatch) => {
  try {
    const res = await axios.post(
      `/api/notification/declinecasualfriend/${channelid}`
    );

    dispatch({
      type: FOLLOWER_NOTIFICATION,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: NOTIFICATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Remove any "user followed" notifications when user requests to unfollow
export const removeUserFollowedNotifications =
  (channelid) => async (dispatch) => {
    try {
      const res = await axios.post(`/api/notification/unfollow/${channelid}`);

      dispatch({
        type: FOLLOWER_NOTIFICATION,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: NOTIFICATION_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Remove any "Casual Friend added" notifications when user requests to remove Casual Friend
export const removeCasualFriendNotifications =
  (channelid) => async (dispatch) => {
    try {
      const res = await axios.post(
        `/api/notification/removecasualfriend/${channelid}`
      );

      dispatch({
        type: FOLLOWER_NOTIFICATION,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: NOTIFICATION_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Remove any "Casual Friend request" notifications when user requests to remove Casual Friend
export const cancelCasualFriendNotifications =
  (channelid) => async (dispatch) => {
    try {
      const res = await axios.post(
        `/api/notification/cancelcasualfriend/${channelid}`
      );

      dispatch({
        type: FOLLOWER_NOTIFICATION,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: NOTIFICATION_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// New approval request notification
export const newApprovalRequestNotification =
  (channelid) => async (dispatch) => {
    try {
      const res = await axios.post(`/api/notification/approval/${channelid}`);

      dispatch({
        type: APPROVAL_NOTIFICATION,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: NOTIFICATION_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// New approval request notification
export const cancelApprovalRequestNotification =
  (channelid) => async (dispatch) => {
    try {
      const res = await axios.post(
        `/api/notification/cancelapproval/${channelid}`
      );

      dispatch({
        type: APPROVAL_NOTIFICATION,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: NOTIFICATION_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };

// Decline approval request notification
export const declineApprovalRequestNotification =
  (channelid) => async (dispatch) => {
    try {
      const res = await axios.post(
        `/api/notification/declineapproval/${channelid}`
      );

      dispatch({
        type: APPROVAL_NOTIFICATION,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: NOTIFICATION_ERROR,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  };
